import CloseIcon from "@mui/icons-material/Close";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import { allIcons } from "../../../assets";
import globalStyle from "../../../globalStyle";
import CustomDropDown from "../../../components/CutomDropDown";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const banks = ["Cash payment", "MTN Money", "Orange Mobile Money"];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const CreateStudentRequestDialog = forwardRef(({ handleClick }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Box p={2}>
        <Typography fontSize={"1.25rem"} fontWeight={600} lineHeight={1}>
          Student Card Request
        </Typography>
        <Typography fontSize={"0.79rem"} color={"custom.slateGrey"}>
          200 USD for ID card cost
        </Typography>
      </Box>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label labelText="Installment(auto)" />
            <TextInput
              styleProps={globalStyle.textField}
              InputStartIcon={
                <img src={allIcons.cashBundleBlackIcon} width={20} />
              }
              InputEndIcon={"USD"}
              value={200}
              readonly
            />
          </Grid>
          <Grid item xs={12}>
            <Label labelText="Select payment type" />
            <CustomDropDown icon={<AccountBalanceIcon htmlColor="#000000" />}>
              {banks.map((val, _i) => (
                <MenuItem key={_i}>{val}</MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_outlined"}
          btnText={"Close"}
          handleClickBtn={handleClose}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />

        <GlobalButton
          btnText={"Pay"}
          handleClickBtn={handleClick}
          styleProps={{
            height: 38,
            width: 100,

            borderRadius: "6px",
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default CreateStudentRequestDialog;
